function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-sensEcoulement");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-sensEcoulement",
  stroke: "#3D6DCC",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.2459413,27.2593975 L21.0210378,22.102261 C20.7898509,21.8710741 20.6409995,21.6213275 20.5517702,21.3581411 L20.5087667,21.2082229 L20.4956725,21.1583113 C20.130646,19.5407934 21.7075997,17.485522 20.3204783,16.0984006 C19.404906,15.1828283 17.9345004,15.822352 16.5154169,16.3180293 L16.1117667,16.4532229 L15.9066875,16.5183476 C15.0309114,16.7819525 14.2100647,16.8916004 13.5952034,16.4239091 L13.4327345,16.2817246 C12.7134864,15.5624765 12.8002421,14.6299028 13.0012589,13.6670876 L13.1037667,13.2002229 L13.1740901,12.890406 C13.3999747,11.8641582 13.5456763,10.8591325 12.7814752,10.0949314 C12.0332141,9.34667028 11.1909468,9.40124612 10.3386074,9.54184022 L9.8047667,9.63322292 L9.62211595,9.66443515 C8.87288458,9.78109299 8.13405297,9.80893412 7.46281982,9.25946663 L7.2814752,9.09493142 C6.24301886,8.05647508 6.6053373,6.71274437 5.81788596,5.33188463 L5.8007667,5.30422292 L5.68362481,5.11358469 C5.53906508,4.89505438 5.36249405,4.67595027 5.14387166,4.45732788 L3.4677667,2.78122292 M26.2459413,23.0167568 L26.2459413,27.2593975 M26.2459413,27.2593975 L22.0033006,27.2593975",
  id: "Combined-Shape"
})));

const SvgIco30SensEcoulement = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30SensEcoulement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-sensEcoulement.6ba54180.svg";
export { ForwardRef as ReactComponent };